import { frontendURL } from 'dashboard/helper/URLHelper';
import {
  CONVERSATION_PERMISSIONS,
  ROLES,
} from 'dashboard/constants/permissions';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/customer-requests'),
    name: 'customer_requests_index',
    meta: {
      permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
    },
    component: () => import('./Index.vue'),
  },
];
